import { z } from 'zod';
import { PROMOTION_DISCOUNT_TYPES } from './constants.js';
export { PROMOTION_DISCOUNT_TYPES } from './constants.js';
export const promotionDiscountTypeSchema = z.enum(PROMOTION_DISCOUNT_TYPES);
export const promotionPriceDiscountTypeSchema = promotionDiscountTypeSchema.extract([
    'percentage',
    'fixed',
]);
